import React, { useEffect, useState, useCallback } from "react";
import Navbar from "../components/Navbar";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { Send } from "lucide-react";

export default function Messages() {
  const { user } = useAuth();
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");

  const loadThreads = useCallback(async () => {
    try { const { data } = await api.get("/messages"); setThreads(data); } catch (e) { toast.error(formatApiError(e)); }
  }, []);
  const openThread = async (otherId) => {
    setActive(otherId);
    const { data } = await api.get(`/messages/${otherId}`);
    setMsgs(data);
  };
  useEffect(() => { loadThreads(); }, [loadThreads]);

  const send = async () => {
    if (!text.trim() || !active) return;
    try {
      const { data } = await api.post("/messages", { to_user_id: active, text });
      setMsgs((m) => [...m, data]); setText("");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="min-h-screen bg-black text-white grain">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-10">
        <h1 className="font-display text-4xl uppercase font-bold tracking-tight">Messages</h1>
        <div className="mt-6 grid md:grid-cols-3 gap-4 min-h-[60vh]">
          <div className="border border-white/10 bg-[#141414]">
            {threads.length === 0 && <div className="p-4 text-white/50 text-sm">No conversations yet.</div>}
            {threads.map((t) => (
              <button
                key={t.thread_id}
                onClick={() => openThread(t.other?.id)}
                data-testid={`thread-${t.other?.id}`}
                className={`w-full text-left p-4 border-b border-white/5 hover:bg-white/[0.03] ${active === t.other?.id ? "bg-white/[0.05]" : ""}`}
              >
                <div className="font-bold text-sm">{t.other?.name}</div>
                <div className="text-xs text-white/50 truncate mt-1">{t.last?.text}</div>
              </button>
            ))}
          </div>
          <div className="md:col-span-2 border border-white/10 bg-[#141414] flex flex-col">
            <div className="flex-1 p-4 space-y-3 overflow-y-auto">
              {!active && <div className="text-white/40 text-sm">Select a conversation</div>}
              {msgs.map((m) => (
                <div key={m.id} className={`max-w-md p-3 text-sm ${m.from_user_id === user.id ? "ml-auto bg-[#e65f2b] text-black" : "bg-white/10"}`}>
                  {m.text}
                </div>
              ))}
            </div>
            {active && (
              <div className="p-3 border-t border-white/10 flex gap-2">
                <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} data-testid="message-input" className="bg-transparent border-white/20 rounded-sm" placeholder="Type a message…" />
                <Button onClick={send} data-testid="send-message-btn" className="bg-[#e65f2b] hover:bg-[#c54a1c] text-black font-bold rounded-sm"><Send size={16} /></Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
